import { Helmet } from "react-helmet-async";

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  type = "website",
  noindex = false,
  image,
  faqData,
  breadcrumbs,
  price,
  priceCurrency = "CAD"
}) => {
  const siteName = "CanadaTestPrep";
  const siteUrl = "https://canadatestprep.ca";
  const defaultDescription = "Prepare for your Canadian Citizenship Test with CanadaTestPrep. 500+ practice questions based on Discover Canada, realistic mock exams, flashcards, and study guides. Free tier available. Start studying today.";
  const defaultKeywords = "Canadian citizenship test, citizenship exam prep, Discover Canada, citizenship test practice, Canadian citizenship questions, citizenship mock test, Canada citizenship 2026, citizenship test study guide, Canadian citizenship test free, practice test Canada";
  const defaultImage = `${siteUrl}/og-image.png`;
  
  const fullTitle = title 
    ? `${title} | ${siteName}` 
    : `${siteName} - Canadian Citizenship Test Prep | Free Practice Questions`;

  const pageDescription = description || defaultDescription;
  const pageImage = image || defaultImage;
  const pageCanonical = canonical || null;

  // Build FAQ structured data if provided
  const faqSchema = faqData ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  } : null;

  // Build breadcrumb structured data if provided
  const breadcrumbSchema = breadcrumbs ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": crumb.url ? `${siteUrl}${crumb.url}` : undefined
    }))
  } : null;

  return (
    <Helmet>
      <title>{String(fullTitle)}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={String(fullTitle)} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={pageCanonical || siteUrl} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={String(fullTitle)} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      
      {/* Canonical */}
      {pageCanonical && <link rel="canonical" href={pageCanonical} />}
      
      {/* FAQ Schema */}
      {faqSchema && (
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      )}
      
      {/* Breadcrumb Schema */}
      {breadcrumbSchema && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
